import { Button } from 'antd';
import { LoginOutlined } from '@ant-design/icons';
import { FunctionFieldProps, FunctionField, Link } from 'react-admin';

import { useQuery } from '@hooks';
import { querySerialize } from '@utils';
import { Dealer, DealerType } from '@types';
import cls from './CountUsersBtn.module.css';


export const CountUsersBtn = (props: Partial<FunctionFieldProps>) => {
  return (
    <FunctionField
      {...props}
      sortable={false}
      render={(record: Dealer) => (
        <UserLoginWidget dealer={record} />
      )}
    />
  );
};

const UserLoginWidget = ({ dealer }: {dealer: Dealer}) => {
  const query = useQuery();
  const filter = query.get('filter');
  const filterObj: any = filter ? JSON.parse(filter) : {};

  const linkToUsers = '/user?' + querySerialize({
    filter: JSON.stringify({
      buyer: dealer.type === DealerType.BUYER ? dealer.name : undefined,
      retailer: dealer.type === DealerType.RETAILER ? dealer.name : undefined,
      associate: dealer.type === DealerType.ASSOCIATE ? dealer.name : undefined,
      createdAt: filterObj.userCreatedAt || undefined,
    }),
    displayedFilters: JSON.stringify({
      buyer: dealer.type === DealerType.BUYER ? true : undefined,
      retailer: dealer.type === DealerType.RETAILER ? true : undefined,
      associate: dealer.type === DealerType.ASSOCIATE ? true : undefined,
      createdAt: filterObj.userCreatedAt || undefined,
    }),
  });

  return (
    <div onClick={e => e.stopPropagation()} className={cls.box}>
      <div className={cls.counter}>{dealer.countUsers ?? 0}</div>
      <Link to={linkToUsers}>
        <Button
          icon={<LoginOutlined className={cls.icon} />}
          type="ghost"
          className={cls.btn}
          title="Go to Users"
        />
      </Link>
    </div>
  );
};
